module.exports = __webpack_public_path__ + "img/ganyong.d949e035.jpg";